//
//
//
//
//
//
//
//

import Vue from "vue";
export default {
  name: "footerNav",
  props: {
  },
  computed: {
  },
  data: {
  },
  methods: {
    tohome(){
      this.$router.replace({name:'home'})
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/homeTip.vue